import React, { useEffect, useState } from 'react';
import styles from './ForumOverview.module.less';
import classNames from 'classnames';
import { createSelector } from 'reselect';
import { useSelector, useDispatch } from 'react-redux';
import { setForumAction, removeForumAction } from '../../../actions/forum';
import Login from '../../../components/Forum/Login/Login';
import { formatNumber } from '../../../utils/utils';
import { logging, logPostInfo } from '../../../actions/log';

const selectForum = createSelector(
  state => state.forum,
  forum => forum,
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

export default ({ forumDetail, commentNode }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const { forumCommentList } = useSelector(selectForum);
  const [loginStatus, setLoginStatus] = useState(false);
  const [loginPanel, setLoginPanel] = useState(false);
  const [publishParams, setPublishParams] = useState(false);

  const handleSkip = () => {
    if (commentNode) {
      dispatch(
        logging({
          category: 'C',
          action: 'Forum_Detail_Scroll',
          label: '',
          param2: {
            source: 'Forum_Detail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            id: forumDetail.id,
          },
        }),
      );
      commentNode.scrollIntoView({ block: 'center' });
    }
  };

  const handleAction = (type, action) => () => {
    if (!loginStatus) {
      setLoginPanel(true);
      setPublishParams([type, action]);
      return;
    }
    setPublishParams(null);

    dispatch(
      logging({
        category: 'C',
        action: 'Forum_Detail_CollectZan',
        label: '',
        param2: {
          source: 'Forum_Detail',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          type: type === 1 ? 'collect' : 'zan',
          action: action === 0 ? 'add' : 'remove',
          id: forumDetail.id,
        },
      }),
    );

    if (!action) {
      // 1-收藏，2-点赞
      dispatch(
        setForumAction({
          actionType: type,
          targetId: forumDetail.id,
        }),
      );
    } else {
      dispatch(
        removeForumAction({
          actionType: type,
          targetId: forumDetail.id,
        }),
      );
    }
  };

  useEffect(() => {
    if (loginStatus && publishParams) {
      handleAction(...publishParams)();
    }
  }, [loginStatus, publishParams]);

  return (
    <>
      <div className={styles.overview}>
        <div
          className={classNames(styles.overview_item, forumDetail.hasCollect && styles.active)}
          onClick={handleAction(1, forumDetail.hasCollect)}
        >
          <i
            className={classNames(
              'iconfont',
              forumDetail.hasCollect ? 'icon-collected' : 'icon-collect',
            )}
          ></i>
          <span>{formatNumber(forumDetail.collectCount || 0)}</span>
        </div>
        <div
          className={classNames(styles.overview_item, forumDetail.hasZan && styles.active)}
          onClick={handleAction(2, forumDetail.hasZan)}
        >
          <i
            className={classNames('iconfont', forumDetail.hasZan ? 'icon-zaned' : 'icon-new_zan')}
          ></i>
          <span>{formatNumber(forumDetail.zanCount || 0)}</span>
        </div>
        <div className={styles.overview_item} onClick={handleSkip}>
          <i className={classNames('iconfont', 'icon-comment')}></i>
          <span>
            {formatNumber(
              (forumCommentList && forumCommentList.dataList && forumCommentList.dataList.length) ||
                0,
            )}
          </span>
        </div>
      </div>
      <Login
        getLoginStatus={state => setLoginStatus(state)}
        callLoginPanel={loginPanel}
        resetLoginPanel={() => {
          setLoginPanel(false);
        }}
      />
    </>
  );
};
